var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtTrustedLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50042 0.250001C6.51524 0.249512 5.53957 0.371399 4.62922 0.608691C3.71888 0.845983 2.89174 1.19403 2.1951 1.63291C1.49847 2.07178 0.946011 2.59288 0.569355 3.16639C0.192698 3.73991 -0.000774501 4.35458 2.33008e-06 4.97524C2.33008e-06 8.51864 7.50042 13.75 7.50042 13.75C7.50042 13.75 15 8.51864 15 4.97524C15.0008 4.35462 14.8074 3.74 14.4307 3.16652C14.0541 2.59304 13.5017 2.07196 12.8052 1.63309C12.1087 1.19422 11.2816 0.846177 10.3714 0.608854C9.46112 0.37153 8.48554 0.249582 7.50042 0.250001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27176 6.96093L11.5283 3.61902L10.4017 2.90396L6.27176 5.53081L4.60509 4.47072L3.47852 5.18578L6.27176 6.96093Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtTrustedLocation);
export default __webpack_public_path__ + "static/media/bt-trusted-location.22996dbcd335e9014e10403fdbad9ae1.svg";
export { ForwardRef as ReactComponent };